var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 8.53809V14.815C6.10794 16.015 6.20024 17.5842 6.29256 18.6919C6.38486 19.9842 7.49255 20.9996 8.78486 20.9996H15.6156C16.9079 20.9996 18.0156 19.9842 18.108 18.6919C18.2002 17.5842 18.2926 16.015 18.3849 14.815C18.4771 13.4304 18.3849 10.5688 18.3849 8.53809H6.01562Z",
    fill: "#7F7F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6616 5.76923H16.3539L15.6154 4.38461C15.1539 3.55385 14.3231 3 13.4 3H11.1846C10.2615 3 9.33846 3.55385 8.96923 4.38461L8.04616 5.76923H5.73846C5.36923 5.76923 5 6.13846 5 6.5077C5 6.87692 5.36923 7.24615 5.73846 7.24615H18.6616C19.0307 7.24615 19.4 6.96923 19.4 6.5077C19.4 6.04616 19.0307 5.76923 18.6616 5.76923ZM9.61539 5.76923L10.0769 5.03077C10.2615 4.66154 10.6308 4.38461 11.0923 4.38461H13.3077C13.7692 4.38461 14.1384 4.56923 14.3231 5.03077L14.7846 5.76923H9.61539Z",
    fill: "#7F7F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteGrey);
export default __webpack_public_path__ + "static/media/icon_delete_grey.154ad9dac3e8a182aba9cf4f13a176b8.svg";
export { ForwardRef as ReactComponent };